// 验证输入内容是否为保留2位小数的数字 包含0
export function numberValidate(rule, value, callback) {
  if (value === "") {
    callback(new Error("请输入内容"));
  } else {
    // 保留两位小数
    if (/^((([1-9][0-9]*)|0)|((([1-9][0-9]*)|0)\.[0-9]{1,2}))$/.test(value)) {
      callback();
    } else {
      callback(new Error("请输入纯数字或保留2位小数"));
    }
  }
}

// 保留两位小数，包含0，可为负数
export function negativeNumValidate(rule, val, callback) {
  let value = Math.abs(val);
  if (value === "") {
    callback(new Error("请输入内容"));
  } else {
    // 保留两位小数
    if (/^((([1-9][0-9]*)|0)|((([1-9][0-9]*)|0)\.[0-9]{1,2}))$/.test(value)) {
      callback();
    } else {
      callback(new Error("请输入数字或保留2位小数，可为负数"));
    }
  }
}
